import React from "react";
import { Dropdown } from "flowbite-react";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PrayerSource } from "./PrayerSourceSelector";
import { usePrayerSource } from "../contexts/PrayerSourceContext";

const sources: { id: PrayerSource; nameKey: string; flag: string }[] = [
    { id: "islamiska", nameKey: "sourceIslamiska", flag: "🇸🇪" },
    { id: "vaktija", nameKey: "sourceVaktija", flag: "🇧🇦" },
    { id: "aladhan", nameKey: "sourceAladhan", flag: "🌐" },
];

const PrayerSourceDropdown = () => {
    const { t } = useTranslation();
    const { prayerSource, setPrayerSource } = usePrayerSource();

    const handleSelect = (sourceId: PrayerSource) => {
        setPrayerSource(sourceId);
    };

    const currentSourceInfo = sources.find(s => s.id === prayerSource) || sources[0];

    return (
        <Dropdown
            arrowIcon={false}
            inline
            placement="bottom-end"
            label={
                <div
                    title={t("prayerSourceHint") || "Välj källa för bönetider. Standard är Islamiska Förbundet."}
                    className="flex items-center justify-center h-[30px] sm:h-[34px] px-2 sm:px-3.5 rounded-lg text-sm font-medium bg-white hover:bg-gray-100 text-gray-800 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-700 transition-colors cursor-pointer shadow-sm"
                >
                    <span className="mr-1 sm:mr-1.5 text-base sm:text-lg">{currentSourceInfo.flag}</span>
                    <span className="mr-1 text-xs font-semibold opacity-90">Bönetid</span>
                    <ChevronDown className="h-3.5 w-3.5 sm:h-4 sm:w-4 opacity-70" />
                </div>
            }
        >
            <Dropdown.Header>
                <span className="block text-sm font-bold text-gray-900 dark:text-white">{t("prayerSource") || "Bönetidskälla"}</span>
                <span className="block text-xs font-normal text-gray-500 dark:text-gray-400 mt-0.5">Standard: Islamiska Förbundet</span>
            </Dropdown.Header>
            {sources.map(source => (
                <Dropdown.Item
                    key={source.id}
                    onClick={() => handleSelect(source.id)}
                    className={`flex items-center gap-2 ${prayerSource === source.id ? 'bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300' : ''}`}
                >
                    <span className="text-xl">{source.flag}</span>
                    <span>{t(source.nameKey)}</span>
                </Dropdown.Item>
            ))}
        </Dropdown>
    );
};

export default PrayerSourceDropdown;
